import React from 'react';

export const AuthPage = (props:any) => {
    return (
        <div>{props.children}</div>
    )
};

export default AuthPage;